import {formatDate, formatNumber} from "../../utils/common";
import TableLayout from "../../layouts/TableLayout";
import {tradeAttributes} from "../../constants/headers";
import {BuyIcon, SellIcon, TextWithMargin} from "../../styles/OrdersStyle";
import {Column, Row, TradeTypeBadge} from "../../styles/table";
import CoinMarket from "../common/utils/CoinMarket";
import {DText, Flex} from "../../styles/MarketStyles";
import Text from "../../utils/Text";
import {getTradeTypeColor} from "../../utils/theme";
import {useMainContext} from "../../contexts/main";
import {useProfileQuery} from "../../services/react-query/useProfileQuery";
import {useAuthContext} from "../../contexts/auth";



const History = ({ data }) => {

    const { main: { lang } } = useMainContext()
    const { profile } = useAuthContext()
    const { headers, cs } = tradeAttributes
    const { data: trades } = data

    return (
        <TableLayout
            data={data}
            headers={headers}
            cs={cs}
        >
            {trades?.data?.map((item, idx) => {

                let tradeType = item.order?.type
                if (profile?._id !== item.order?.userId) {
                    tradeType = tradeType === 'buy' ? 'sell' : 'buy'
                }

                return (
                    <Row cs={cs} index={idx} key={item._id}>
                        <Column>
                            {idx + 1}
                        </Column>
                        <Column>
                            <CoinMarket
                                coin={item.order?.coin}
                                pair={item.order?.pair}
                            />
                        </Column>
                        <Column>
                            <DText main fontSize={'s'}>
                                {formatNumber(item.amount)}
                            </DText>
                        </Column>
                        <Column>
                            <DText main fontSize={'s'}>
                                {formatNumber(item.priceUnit)}
                            </DText>
                        </Column>
                        <Column>
                            <DText main fontSize={'s'}>
                                {formatNumber(item.price)}
                            </DText>
                        </Column>
                        <Column>
                            <Flex>
                                {tradeType === "buy" ?
                                    <BuyIcon />
                                    :
                                    <SellIcon />
                                }
                                <TextWithMargin type={tradeType}>
                                    <Text tid={tradeType} />
                                </TextWithMargin>
                            </Flex>
                        </Column>
                        <Column>
                            <TradeTypeBadge color={getTradeTypeColor(item.order?.submit)}>
                                {item.order?.submit}
                            </TradeTypeBadge>
                        </Column>
                        <Column>
                            {`${formatDate(item.createdAt, "time", lang === "en" ? "en-US" : "fa-IR")}
                        -${formatDate(item.createdAt, "date", lang === "en" ? "en-US" : "fa-IR")}`}
                        </Column>
                    </Row>
                )
            })}
        </TableLayout>
    );
};


export default History;
